export class QueryOrganizationCostData400Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return QueryOrganizationCostData400Response.attributeTypeMap;
    }
    constructor() {
    }
}
